import { Helmet } from "react-helmet-async";
import {
  Container,
  Typography,
  Divider,
  Stack,
  Button,
  Box,
} from "@mui/material";
import useResponsive from "../hooks/useResponsive";
import Iconify from "../components/iconify";
import { LoginForm } from "../sections/auth/login";

// ----------------------------------------------------------------------

const IMAGES = {
  logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Logo_ICONTEC_Horizontal.svg/2560px-Logo_ICONTEC_Horizontal.svg.png",
  sideImg:
    "https://us.123rf.com/450wm/merfin/merfin1606/merfin160600211/57553513-car%C3%A1cter-vectorial-detallada-oficinista-empleado-de-oficina-de-negocios-en-acciones-la-gente-de.jpg?ver=6",
};

// Reusable button component
const CustomButton = ({
  onClick,
  text,
  icon,
  gradient,
  hoverGradient,
  shadow,
}) => (
  <Button
    onClick={onClick}
    fullWidth
    size="large"
    variant="contained"
    startIcon={icon}
    sx={{
      background: gradient,
      color: "#fff",
      fontWeight: "bold",
      borderRadius: "12px",
      textTransform: "uppercase",
      letterSpacing: "1px",
      boxShadow: shadow,
      transition: "all 0.3s ease-in-out",
      "&:hover": {
        background: hoverGradient,
        transform: "scale(1.05)",
        boxShadow: shadow.replace("0.4", "0.6"),
      },
    }}
  >
    {text}
  </Button>
);

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive("up", "md");

  const postData = () => {
    window.location.href =
      "https://middlewarebackprd.azurewebsites.net/api/v1/AuthAzure";
  };

  const consulta = () => {
    window.location.href = "/";
  };

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>

      <Box display={{ md: "flex" }}>
        {mdUp && (
          <Box
            sx={{
              width: "100%",
              maxWidth: 480,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              boxShadow: 3,
              bgcolor: "background.default",
            }}
          >
            <Typography
              variant="h3"
              sx={{ px: 5, mt: 10, mb: 5 }}
              color={"#0085CA"}
            >
              Bienvenido De Nuevo a Huella De Confianza
            </Typography>
            <img src={IMAGES.sideImg} alt="login" width={200} />
          </Box>
        )}

        <Container maxWidth="sm">
          <Box
            sx={{
              maxWidth: 480,
              mx: "auto",
              minHeight: "100vh",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              py: 12,
            }}
          >
            <center>
              <img src={IMAGES.logo} alt="logo" width={200} />
            </center>

            <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Inicio de sesión
              </Typography>
            </Divider>

            <Stack direction="row" spacing={2}>
              <CustomButton
                onClick={postData}
                text="Microsoft"
                icon={<Iconify icon="mdi:microsoft" width={24} height={24} />}
                gradient="linear-gradient(90deg, #0078D4 0%, #00A4EF 100%)"
                hoverGradient="linear-gradient(90deg, #005a9e 0%, #0078D4 100%)"
                shadow="0 4px 12px rgba(0, 120, 212, 0.4)"
              />
            </Stack>

            <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Consulta Pública
              </Typography>
            </Divider>

            <LoginForm />
            <hr />

            <Stack direction="row" spacing={2}>
              <CustomButton
                onClick={consulta}
                text="Consulta Pública"
                icon={<Iconify icon="il:search" width={24} height={24} />}
                gradient="linear-gradient(90deg, #DF3E30 0%, #FF6B6B 100%)"
                hoverGradient="linear-gradient(90deg, #B83227 0%, #DF3E30 100%)"
                shadow="0 4px 12px rgba(223, 62, 48, 0.4)"
              />
            </Stack>
          </Box>
        </Container>
      </Box>
    </>
  );
}
